// extracted by mini-css-extract-plugin
module.exports =  {"tc-header-icon":"HeaderIcon-module__tc-header-icon___kpgTo"};